export const GUEST = 0;
export const BASIC = 10;
export const GOLD = 30;
export const GOLD_FREE = 31;
export const GOLD_PROMO = 33;
export const PERFORMER = 40;
export const SPECIAL_PERFORMER = 45;
export const COACH = 48;
export const USER_MODERATOR = 47;
export const ACCESS_LEVEL_STR = {
  UNVERIFIED: 'unverified',
  GUEST: 'guest',
  GENERAL: 'general',
  GOLD: 'gold',
  GOLD_FREE: 'goldFree',
  GOLD_PROMO: 'goldPromo',
  PERFORMER: 'performer',
  USER_MODERATOR: 'userModerator',
  COACH: 'coach',
  MODERATOR: 'moderator',
  ADMIN: 'admin',
  VERIFIED_ROOM_MODERATOR: 'verifiedRoomModerator',
  UNKNOWN: 'unknown',
};
export const isAnyTypeOfGold = (accessLevel) => {
  let isGold = false;
  if (!isNaN(accessLevel)) {
    if (accessLevel >= GOLD) {
      isGold = true;
    } else {
      isGold = false;
    }
  } else {
    isGold = [
      ACCESS_LEVEL_STR.GOLD,
      ACCESS_LEVEL_STR.GOLD_FREE,
      ACCESS_LEVEL_STR.GOLD_PROMO,
      GOLD,
      GOLD_FREE,
      GOLD_PROMO,
    ].includes(accessLevel);
  }

  return isGold;
};
